import React from 'react';
import copy from 'copy-to-clipboard';
import { Box, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colorPalette } from '@qualifio/ui-commons';
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { useTranslation } from 'react-i18next';

export function IncomingWebhookUrl({ url }: { url: string }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: colorPalette.blue.lightest,
        border: `1px solid ${colorPalette.blue.main}`,
        borderRadius: '5px',
        padding: '20px',
      }}
    >
      <Box>
        <Box mb={0.3}>
          <b>{t('incoming-webhooks.url.title')}</b>
        </Box>
        <Box mb={0.5}>{t('incoming-webhooks.url.description')}</Box>
        <CodeSnippet>{url}</CodeSnippet>
      </Box>
    </Box>
  );
}

function CodeSnippet({ children }: { children: string }) {
  return (
    <Box
      component="pre"
      sx={{
        background: colorPalette.white.main,
        border: `1px solid ${colorPalette.grey.main}`,
        margin: 0,
        position: 'relative',
      }}
    >
      <Box
        component="code"
        sx={{
          padding: '5px 10px',
          display: 'block',
        }}
      >
        {children}
      </Box>
      <IconButton
        onClick={() => copy(children)}
        sx={{ position: 'absolute', right: 0, top: 0, height: '100%' }}
      >
        <FontAwesomeIcon icon={faCopy} />
      </IconButton>
    </Box>
  );
}
